import React, { useEffect, useState } from "react";
import "../CSS/ProfileTenagaKesehatan.css";
import { useNavigate, useParams } from "react-router-dom";

function ProfileDokterParuAdmin() {
    const { id } = useParams();

    const [dokterData, setDokterData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);

    // =========================
    // GET DATA DOKTER PARU
    // =========================
    useEffect(() => {
        const fetchDokter = async () => {
            try {
                const res = await fetch(
                    `https://api-tibismart.tifpsdku.com/api/dokter-paru/${id}`
                );

                if (!res.ok)
                    throw new Error("Gagal mengambil data dokter paru");

                const data = await res.json();

                console.log(data);

                setDokterData(data.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDokter();
    }, [id]);

    // =========================
    // HANDLE INPUT
    // =========================
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setDokterData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // =========================
    // SAVE
    // =========================
    const handleSave = async () => {
        try {
            const payload = {
                nama_lengkap: dokterData.nama_lengkap,
                email: dokterData.email,
                no_telepon: dokterData.no_telepon,
                spesialisasi: dokterData.spesialisasi,
                no_str: dokterData.no_str,
                tempat_bekerja: dokterData.tempat_bekerja,
                alamat_praktik: dokterData.alamat_praktik,
            };

            const res = await fetch(
                `https://api-tibismart.tifpsdku.com/api/dokter-paru/${id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok)
                throw new Error("Gagal mengupdate data.");

            const data = await res.json();

            console.log(data);

            setEditing(false);

            alert("Data berhasil diperbarui.");
        } catch (err) {
            console.error(err);
            alert("Gagal mengupdate data.");
        }
    };

    if (loading) return <p>Loading data...</p>;

    if (!dokterData) return <p>Data tidak ditemukan.</p>;

    return (
        <div className="profile-page">
            <div className="main-contentprofile">
                <div className="content-profile">
                    {/* Profile Card */}
                    <div className="profile-card">
                        <div className="profile-avatar">
                            {dokterData.foto_profil ? (
                                <img
                                    src={`https://api-tibismart.tifpsdku.com/${dokterData.foto_profil}`}
                                    alt={dokterData.nama_lengkap}
                                    className="avatar-image"
                                />
                            ) : (
                                <span>
                                    {dokterData.nama_lengkap
                                        ? dokterData.nama_lengkap[0].toUpperCase()
                                        : "D"}
                                </span>
                            )}
                        </div>
                        <div className="profile-info">
                            <h3>{dokterData.nama_lengkap}</h3>

                            <p>
                                {dokterData.spesialisasi || "Dokter Paru"}
                            </p>

                            <p className="nip">
                                STR. {dokterData.no_str}
                            </p>
                        </div>
                    </div>

                    {/* Tabs */}
                    <div className="tab-section">
                        <button className="tab active">Informasi</button>

                    </div>

                    {/* Form Section */}
                    <div className="form-sectionprofile">
                        <div className="form-row">
                            <div className="form-groupprofile">
                                <label>Nama Lengkap</label>
                                <input
                                    type="text"
                                    name="nama_lengkap"
                                    value={dokterData.nama_lengkap}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                            <div className="form-groupprofile">
                                <label>Email</label>
                                <input
                                    type="text"
                                    name="email"
                                    value={dokterData.email || ""}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-groupprofile">
                                <label>No. Telepon</label>
                                <input
                                    type="text"
                                    name="no_telepon"
                                    value={dokterData.no_telepon}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                            <div className="form-groupprofile">
                                <label>Spesialisasi</label>
                                <input
                                    type="text"
                                    name="spesialisasi"
                                    value={dokterData.spesialisasi || ""}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-groupprofile">
                                <label>No. STR</label>
                                <input
                                    type="text"
                                    name="no_str"
                                    value={dokterData.no_str}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                            <div className="form-groupprofile">
                                <label>Tempat Bekerja</label>

                                <input
                                    type="text"
                                    name="tempat_bekerja"
                                    value={dokterData.tempat_bekerja || ""}
                                    onChange={handleInputChange}
                                    readOnly={!editing}
                                />
                            </div>
                        </div>

                        
                                <div className="form-row">
                                    <div className="form-groupprofile">
                                        <label>Alamat Praktik</label>

                                        <input
                                            type="text"
                                            name="alamat_praktik"
                                            value={dokterData.alamat_praktik || ""}
                                            onChange={handleInputChange}
                                            readOnly={!editing}
                                        />
                                    </div>
                                </div>

                        <div className="verification-section">
                            <h3>Dokumen Verifikasi</h3>

                            <div className="verification-grid">

                                {/* FOTO SELFIE */}
                                <div className="verification-card">
                                    <h4>Foto Verifikasi Wajah</h4>

                                    {dokterData.foto_verifikasi ? (
                                        <>
                                            <img
                                                src={`https://api-tibismart.tifpsdku.com/${dokterData.foto_verifikasi}`}
                                                alt="Foto Verifikasi"
                                                className="verification-image"
                                            />

                                            <a
                                                href={`https://api-tibismart.tifpsdku.com/${dokterData.foto_verifikasi}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="download-btn"
                                            >
                                                Lihat Full Foto
                                            </a>
                                        </>
                                    ) : (
                                        <p>Foto verifikasi tidak tersedia</p>
                                    )}
                                </div>

                                {/* DOKUMEN */}
                                <div className="verification-card">
                                    <h4>Dokumen STR</h4>

                                    {dokterData.file_str ? (
                                        <>
                                            <p>{dokterData.file_str.split("/").pop()}</p>

                                            <a
                                                href={`https://api-tibismart.tifpsdku.com/${dokterData.file_str}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="download-btn"
                                            >
                                                Buka Dokumen
                                            </a>
                                        </>
                                    ) : (
                                        <p>Dokumen STR tidak tersedia</p>
                                    )}
                                </div>
                                <div className="verification-card">
                                    <h4>Dokumen Pendukung</h4>

                                    {dokterData.file_pendukung ? (
                                        <>
                                            <p>{dokterData.file_pendukung.split("/").pop()}</p>

                                            <a
                                                href={`https://api-tibismart.tifpsdku.com/${dokterData.file_pendukung}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="download-btn"
                                            >
                                                Buka Dokumen
                                            </a>
                                        </>
                                    ) : (
                                        <p>Dokumen pendukung tidak tersedia</p>
                                    )}
                                </div>

                            </div>
                        </div>

                        <div className="btn-edit-container">
                            {!editing ? (
                                <button className="edit-btn" onClick={() => setEditing(true)}>Edit Profile</button>
                            ) : (
                                <button className="edit-btn" onClick={handleSave}>Simpan Perubahan</button>
                            )}
                        </div>
                    </div>


                    <footer className="footerdebar">
                        © 2025 TibiSmart. All rights reserved.
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default ProfileDokterParuAdmin;
